import Vue from 'vue';
import App from './App.vue';
import Toasted from 'vue-toasted';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './styles/main.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { dom } from '@fortawesome/fontawesome-svg-core';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';

dom.watch();

library.add(fas, far, fab);

Vue.config.productionTip = false;

Vue.use(Toasted);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
